import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorageService {
  public getParsedItem(key: string) {
    return JSON.parse(sessionStorage.getItem(key) ?? 'null');
  }

  public getItem(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  public setItem(key: string, value: any) {
    return sessionStorage.setItem(key, JSON.stringify(value));
  }

  public removeItem(key: string) {
    return sessionStorage.removeItem(key);
  }

  public clear() {
    sessionStorage.clear();
  }
}
